import { Incident } from "./../types/Incidents";
import { $http } from "@/plugins/api";
import { Collection, Params } from "@/types/api";
import { Commit } from "vuex";
interface IncidentsState {
  incidentsList: Collection<Incident>;
  selectedIncident: Incident | null;
}

const defaultIncidentsList = {
  current_page: 1,
  page_size: 10,
  results: [],
  total: 0,
};

const state: IncidentsState = {
  incidentsList: defaultIncidentsList,
  selectedIncident: null,
};

const getters = {
  collection: (state: IncidentsState) => state.incidentsList,
  selectedIncident: (state: IncidentsState) => state.selectedIncident,
};

const actions = {
  async getIncidentsList(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
      params,
    }: {
      globalOrganisationID: string;
      params: Params;
    },
  ) {
    commit("resetIncidentsList");

    const searchParams = new URLSearchParams(params);

    const res = await $http.get(
      `${
        import.meta.env.VITE_API_CLIENT_V2
      }/history/${globalOrganisationID}/incidents?${searchParams.toString()}`,
    );

    commit("setIncidentsList", res.data);
  },
};

const mutations = {
  setIncidentsList: (state: IncidentsState, data: Collection<Incident>) =>
    (state.incidentsList = data),
  setSelectedIncident: (state: IncidentsState, data: Incident) =>
    (state.selectedIncident = data),
  resetIncidentsList: (state: IncidentsState) =>
    (state.incidentsList = defaultIncidentsList),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
